  <template>
   <b-modal style="padding:15px" size="lg" id="EditFlourWeightModal" ref="modal" title="Edit Flour Weight" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditFlourWeightForm != undefined ? !this.$refs.EditFlourWeightForm.checkValidity() : true">
        <form ref="EditFlourWeightForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-12">
               <b-form-group  label="Name" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "Weight" type= "number" required></b-form-input>
              </b-form-group>
            </div>
         
          </div>     
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'EditFlourWeight',
    data(){
        return{
          moduleName:'Edit Flour Weight',   
          Weight:0,
          Id:null,
          CompanyId:null,
         
		}
  },

props:{
  flourWeight:{
    type:Object,
    default:null
  }
},

methods:{
  
   editFlourWeight(){ 
        
     axios.post('/flourweight/edit', 
      {"Id":this.Id,"Weight":Number(this.Weight), "CompanyId":this.$auth.user().companyId
      })
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Flour Type has been added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go();
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditFlourWeightForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.Weight = 0;  
      },
       updateModal()
      {
        console.log(this.flourWeight)
        this.Weight = this.flourWeight.weight;
        this.Id = this.flourWeight.id;
        
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editFlourWeight()
       
      },

 

  }
	

}
</script>
